/* Shim for the forked design editor (features/design/editor): the StudioCore AuthContext shape over
 * the Brightivity sign-in. user = { token, id, userId, email, name, org fields, tier, masterAdmin } (/auth/me).
 * tier + masterAdmin drive the printables price: A, B and master admins save printables free. */
import { useSession } from '../app/session.jsx';

export function useAuth() {
  const s = useSession();
  const session = s && s.session;
  const user = session && session.token ? { token: session.token, id: session.userId, userId: session.userId, email: session.email, name: session.name, orgAdmin: !!session.orgAdmin, orgAdminSchoolId: session.orgAdminSchoolId || null, schoolName: session.schoolName || null, schoolId: session.schoolId || null, tier: session.tier || null, masterAdmin: !!session.masterAdmin } : null;
  return { user, isAuthenticated: !!user };
}
export default null;
